import { useCallback, useState } from 'react';

import { Card } from 'reactstrap';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@hsp/react-component-library';

import UserSlideoutInfo from '@p/security/users/dashboard/component/slideout/user-profile/user-info.component';
import { useFetchUsers } from '@p/security/users/dashboard/hook/queries/fetch-users.hook';
import { userStore } from '@p/security/users/store/store';

import { IUserDashboard } from '@t/user/dashboard';

import cssClasses from './card.module.scss';

const UserCards = () => {
  const { data: userData } = useFetchUsers();
  const { setIsOpenUserInfo } = userStore();
  const [checkAction, setCheckAction] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<IUserDashboard>();
  const trimName = useCallback((firstName: string, lastName: string) => {
    const firstInitial = firstName.slice(0, 1);
    const lastInitial = lastName.slice(0, 1);

    return firstInitial?.concat(lastInitial);
  }, []);

  return (
    <>
      <div className="d-flex flex-wrap gap-3">
        {userData?.dataContainer?.map((item, index) => (
          <>
            <Card
              className={classNames('mb-0', cssClasses.userCard)}
              key={index}
              onClick={() => {
                if (!checkAction) {
                  setIsOpenUserInfo(true);
                }
                setCheckAction(false);
                setUserInfo(item);
              }}>
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-start gap-4">
                  <div>
                    <div className={cssClasses.image}>
                      <span className="text-light">{trimName(item.firstName, item.lastName)}</span>
                    </div>
                  </div>

                  <div className=" d-flex flex-column justify-content-end">
                    <span className={cssClasses.userName}>{item.firstName + ' ' + item.lastName}</span>
                    <div>
                      <FontAwesomeIcon
                        className={cssClasses.icon}
                        icon={['fas', 'clock']}
                      />
                      <span className={classNames(cssClasses.lastLogin, 'ms-1')}>Last Login 2PM</span>
                    </div>
                  </div>
                </div>

                <div>
                  <FontAwesomeIcon
                    color="outline-secondary"
                    icon={['fas', 'ellipsis-vertical']}
                    onClickCapture={() => {
                      setIsOpenUserInfo(false);
                      setCheckAction(true);
                    }}

                    // onClick={() => {
                    //   setIsOpenUserInfo(false);
                    //   setCheckAction(true);
                    // }}
                  />
                </div>
              </div>

              <div className="align-items-start mt-2">
                <div className="ms-2">
                  <div>
                    <FontAwesomeIcon icon={'envelope'} />
                    <span className="ms-2">{item.email}</span>
                  </div>
                  <div>
                    <FontAwesomeIcon icon={'user-tag'} />
                    <span className="ms-2">{item.role}</span>
                  </div>
                </div>
              </div>
            </Card>
          </>
        ))}

        <UserSlideoutInfo item={userInfo} />
      </div>
    </>
  );
};

export default UserCards;
